import { getExactDate } from '../../../utils';

type DayInfoItem = { relativeDay: number; exactDate: string };

export function MissionCalendar({
  duration,
  today,
  selectedDay,
  updateCurrentDay,
}: {
  duration: number;
  today: number;
  selectedDay: number;
  updateCurrentDay: (day: number) => void;
}) {
  const dayInfo: DayInfoItem[] = [];

  const limited = Math.min(duration, today);
  for (let i = limited; i > 0; i--) {
    const exactDate = getExactDate(i, today);

    dayInfo.push({
      relativeDay: i,
      exactDate,
    });
  }

  const getDayElement = () => {
    return dayInfo.map((item) => {
      const handleClick = () => {
        updateCurrentDay(item.relativeDay);
      };

      const className =
        selectedDay === item.relativeDay
          ? 'text-sm text-manage-primary bg-white rounded-xl text-center w-full inline-flex justify-center items-center'
          : 'text-sm text-white';
      return (
        <button key={item.relativeDay} onClick={handleClick} className="w-8">
          <div className="flex flex-col items-center flex-grow">
            <span className={className + ''}>{item.relativeDay}</span>
            <span className="text-white text-xs w-6 min-w-fit">
              {item.exactDate}
            </span>
          </div>
        </button>
      );
    });
  };

  return (
    <div className="flex gap-4 overflow-x-scroll overflow-y-hidden items-center h-fit">
      {getDayElement()}
    </div>
  );
}
